import React from 'react';
import { GroupProps } from '@repo/ui/src/types/recipes';

const InlineIngredientSummary = ({ groupKey, ingredients, groupName }: GroupProps) => {
  return (
    <div key={groupKey} className="tw-pb-6">
      <h6 className="tra-text-web-heading-7 tw-text-left tw-mb-0">{groupName}</h6>
      <table className="tw-border-separate tw-border-spacing-y-4">
        <tbody>
          {ingredients.map((ingredient, i) => (
            <tr key={`ingredient_${i}`}>
              <td className="tra-text-web-body-s tw-mb-0 tw-pr-2 tw-border-r">
                {ingredient.imperial?.measurementDisplay} {ingredient.unitOfMeasure}
              </td>
              <td itemProp="recipeIngredient" className="tra-text-web-body-l tw-mb-0 tw-pl-2">
                {ingredient.ingredient?.name}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default InlineIngredientSummary;
